<div class="stat-container">
  <div class="stat-container__item" *ngFor="let item of bannerStatistics; let i = index, trackBy: trackByIndex">
    <span>{{item.key}}: </span>
    <span class="stat-container__count bold">{{item.value}}</span>
  </div>
  <span class="stat-container__tooltip" *ngIf="tooltipMessage">
    <app-tool-tip [text]="tooltipMessage"></app-tool-tip>
  </span>
</div>
